var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgAdd = function SvgAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8 7.2H7.2v3.6c0 .66-.54 1.2-1.155 1.2-.705 0-1.245-.54-1.245-1.2V7.2H1.2C.54 7.2 0 6.66 0 6s.54-1.2 1.2-1.2h3.6V1.2C4.8.54 5.34 0 6 0s1.2.54 1.2 1.2v3.6h3.6c.66 0 1.2.54 1.2 1.2s-.54 1.2-1.2 1.2z",
    fill: "currentColor"
  })));
};

export default SvgAdd;